import Vue from "vue";
import firebase from "firebase";
import App from "./App.vue";
import router from "./router";
import InstantSearch from "vue-instantsearch";

Vue.use(InstantSearch);

require("./assets/sass/main.scss");

Vue.config.productionTip = false;

let app = "";

var firebaseConfig = {
  apiKey: "AIzaSyBiy5AKQxxQw6hcwPBkuj2yaVQ_Hhf4gMs",
  authDomain: "ecp-middleware-redirect.firebaseapp.com",
  databaseURL: "https://ecp-middleware-redirect.firebaseio.com",
  projectId: "ecp-middleware-redirect",
  storageBucket: "ecp-middleware-redirect.appspot.com",
  messagingSenderId: "844140274726",
  appId: "1:844140274726:web:a963281e08cf1e68"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// This will make it so the app does not init until firebase.auth inits
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
});
